const conversationRTLStyles = {
  '.userMessage': {
    borderRadius: '9px 9px 0 9px !important',
  },
  '.customerMessage': {
    borderRadius: '9px 9px 9px 0 !important',
  },
  '.messageInputWrap': {
    padding: '5px 10px 5px 42px !important',
  },
  '.messageInput': {
    textAlign: 'right',
  },
  '.enterIcon': {
    right: 'auto !important',
    left: '10px',
  },
  '.inputWithSubmit': {
    order: 2,
  },
  '.inputWithSubmitIcon': {
    order: 1,
  },
  '.describeEmailTitle': {
    textAlign: 'right',
  },
  '.volumeControlButtonWrap': {
    textAlign: 'right',
  },
  '.chatConvsationInputButtonWrap': {
    textAlign: 'right',
  },
  '.conversationUnreadIcon': {
    right: '58px',
  },
  '.conversationUnreadIcon.centered': {
    right: '185px',
  },
  '.uploadIcon': {
    right: 'auto !important',
    left: '35px',
  },
};

export default conversationRTLStyles;
